import { render, staticRenderFns } from "./vehicle_status_maint_tbn.vue?vue&type=template&id=2208e6d8&scoped=true&"
import script from "./vehicle_status_maint_tbn.vue?vue&type=script&lang=js&"
export * from "./vehicle_status_maint_tbn.vue?vue&type=script&lang=js&"
import style0 from "./vehicle_status_maint_tbn.vue?vue&type=style&index=0&id=2208e6d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2208e6d8",
  null
  
)

export default component.exports